











































import Vue from 'vue';
import Component from 'vue-class-component';
import AuthCard from '@/components/Auth/AuthCard.vue';
import { validators } from '@/utils/validations';
import { Emit, Ref } from 'vue-property-decorator';
import { AuthApi } from '@/api/auth.api';
import { take } from 'rxjs/operators';
import { authModule } from '@/utils/store-acessor';
import { ForgotPasswordModel } from '@/models/forgot-password.model';

@Component({
  components: {
    AuthCard
  }
})
export default class ChangePassword extends Vue {
  readonly rules = validators;
  valid = false;
  error = false;
  loading = false;
  data: ForgotPasswordModel = {
    token: '',
    password_confirmation: '',
    password: '',
    email: ''
  };
  // @ts-ignore
  @Ref() form: VForm;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;

  onChangePassword() {
    if (this.form.validate()) {
      this.error = false;
      this.loading = true;
      this.data.token = this.$route.params.token;
      new AuthApi()
        .resetPassword(this.data)
        .pipe(take(1))
        .subscribe(
          res => this.onSuccess(),
          err => this.onFail()
        );
    }
  }

  @Emit()
  onSuccess(): boolean {
    this.loading = false;
    return true;
  }

  @Emit()
  onFail(): boolean {
    this.error = true;
    this.loading = false;
    return true;
  }
}
